import { gql } from '@apollo/client'

const parsedShortcodesFragment = gql`
  fragment parsedShortcodes on PublicCmsItemBlogPost {
    content
    videoRequestList
  }
`
export default parsedShortcodesFragment
